function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.073 15.927L22 13l-2.927-2.927V5.927h-4.146L12 3 9.073 5.927H4.927v4.146L2 13l2.927 2.927v4.146h14.146v-4.146zM12 18.305A5.31 5.31 0 016.695 13 5.31 5.31 0 0112 7.695 5.31 5.31 0 0117.305 13 5.31 5.31 0 0112 18.305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5H2v1h20v-1z"
  }));
};
const SvgSunrise = styled(BaseComponent).withConfig({
  displayName: "Sunrise__SvgSunrise",
  componentId: "sc-1xh9vb5-0"
})(["outline:none;"]);
SvgSunrise.isIcon = true;
SvgSunrise.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgSunrise;